<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_v"><i><b>Contents</b></i></a></p><a id="page_v">
<div class="image"><img alt="Image" src="images/cmn.jpg"/></div>
</a><p class="tocb"><a id="page_v"></a><a href="#/xhtml/07_Preface"><i>Preface and Acknowledgments</i></a></p>
<p class="toc"><a href="#/xhtml/09_Prologue">Prologue</a></p>
<p class="toc"><a href="#/xhtml/10_Chapter01">1 | In the Beginning: The Lincoln Heritage</a></p>
<p class="toc"><span href="#/xhtml/11_Chapter02" title="Link target outside of Sample">2 | Bardstown and Bourbon</span></p>
<p class="toc"><span href="#/xhtml/12_Chapter03" title="Link target outside of Sample">3 | Lexington, Kentucky: Athens of the West</span></p>
<p class="toc"><span href="#/xhtml/13_Chapter04" title="Link target outside of Sample">4 | Southeastern Indiana Trails</span></p>
<p class="toc"><span href="#/xhtml/14_Chapter05" title="Link target outside of Sample">5 | Southwestern Indiana: Life in Little Pigeon Creek</span></p>
<p class="toc"><span href="#/xhtml/15_Chapter06" title="Link target outside of Sample">6 | Lincoln in Illinois: A River Runs through It</span></p>
<p class="toc"><span href="#/xhtml/16_Chapter07" title="Link target outside of Sample">7 | Other Places along the Way</span></p>
<p class="tocb"><span href="#/xhtml/17_Chapter08" title="Link target outside of Sample">8 | Endings</span></p>
<p class="toc"><span href="#/xhtml/18_Bibliography" title="Link target outside of Sample"><i>Selected Bibliography</i></span></p>
<p class="toc"><span href="#/xhtml/19_Index01" title="Link target outside of Sample"><i>Index of Place Names</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?db08deca